import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // Importante para enviar y recibir cookies HTTP-only
  // Evitar que Axios siga automáticamente las redirecciones
  maxRedirects: 0,
});

// Interceptor de petición para añadir token si existe
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuesta para manejar errores de autenticación
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Solo redirigir a Cognito desde rutas protegidas
    const currentPath = window.location.pathname;
    const publicPaths = [
      '/login',
      '/',
      '/register',
      '/forgot-password',
    ];
    const isPublicPath = publicPaths.includes(currentPath);

    // Manejar redirecciones (status 302) que apuntan a Cognito
    if (error.response?.status === 302 && !isPublicPath) {
      const redirectUrl = error.response.headers.location;
      if (redirectUrl && redirectUrl.includes('amazoncognito.com')) {
        window.location.href = redirectUrl;
        return new Promise(() => {});
      }
    }

    // Si el error es de tipo redirect a Cognito (respuesta del backend)
    if (
      error.response?.status === 401 &&
      error.response?.data?.redirectUrl &&
      !isPublicPath
    ) {
      window.location.href = error.response.data.redirectUrl;
      return new Promise(() => {});
    }

    // Manejar errores 401 sin autenticación solo en rutas protegidas
    if (error.response?.status === 401 && !isPublicPath) {
      window.location.href = `${process.env.REACT_APP_API_URL}/auth/login/redirect`;
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export default api;
